import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import AdmissionELe from '../../IITTP/Admission/AdmissoinEle'


function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Admissions"/>
            <AdmissionELe />
        </>
    )
}

export default Main